// 'Cozy icebreaker gacha game' 프로토타입(Icebreaker Gacha.dc.html) 포팅.
// 질문/팔레트/저장 로직은 프로토타입과 동일하게 유지한다.

export const QUESTIONS = [
  "What's been on your mind this week?",
  "What's a small thing that made you smile recently?",
  'How did today actually go — honestly?',
  "What's your current comfort food?",
  'What time did you wake up today, and how do you feel about it?',
  "What's the last photo you took, and why?",
  "What's a tiny habit that's been saving you lately?",
  'What have you been listening to on repeat?',
  "What's the best thing you ate this week?",
  "What's something you've been putting off?",
  "What's your favorite part of an ordinary day?",
  'What did you do last weekend — and was it enough rest?',
  "What's something recent you're quietly proud of?",
  "What's been draining your energy — and what's been refilling it?",
  "What's the last thing you searched for on your phone?",
  'Describe your morning mood today in three words.',
  "What's a small purchase that improved your daily life?",
  'What are you looking forward to this month?',
  "What's your go-to order at your usual cafe or restaurant?",
  "What's a conversation you've been meaning to have?",
  'What does your ideal weeknight evening look like?',
  "What's new in your routine this season?",
  'Who did you last call — and what about?',
  "What's a small annoyance you've made peace with?",
  "What's the most interesting thing you learned this week?",
  'What app did you use most today — and does that feel right?',
  "What's a place nearby you keep going back to?",
  'What would make tomorrow feel like a good day?',
  "What's a thought you keep coming back to lately?",
  "What's one thing you'd like us to know about your week?",
];

// 올리브 위주 + 테라코타 포인트 (앞 6개가 메인, 뒤 2개는 밝은 색)
export const PALETTE = [
  '#aebf92',
  '#8fa073',
  '#728157',
  '#56633f',
  '#d67f48',
  '#b2622d',
  '#ccdbb2',
  '#eee7db',
];
export const DRAW_PALETTE = [
  '#aebf92',
  '#8fa073',
  '#728157',
  '#d67f48',
  '#f6a06b',
];

export const LID_COLOR = '#7a8a5e';
export const LID_HI = `color-mix(in oklab, ${LID_COLOR} 65%, white)`;

// 'fresh-per-person': 같은 사람에게만 중복 금지 / 'unique-for-everyone': 전체 중복 금지
export const REPEAT_POLICY = 'fresh-per-person';

export const MAX_NAMES = 16;

const SESSION_KEY = 'koready-gacha-v1';
const DATA_KEY = 'koready-gacha-data-v1';

export const qNo = (q) => QUESTIONS.indexOf(q) + 1;

export const loadSession = () => {
  try {
    return JSON.parse(localStorage.getItem(SESSION_KEY));
  } catch (e) {
    return null;
  }
};

export const saveSession = ({ names, turn, history, skipped }) => {
  try {
    localStorage.setItem(
      SESSION_KEY,
      JSON.stringify({ names, turn, history, skipped }),
    );
  } catch (e) {}
};

export const clearSession = () => {
  try {
    localStorage.removeItem(SESSION_KEY);
  } catch (e) {}
};

// --- Data layer: per-user analytics, kept separate from UI state ---
const loadData = () => {
  try {
    return (
      JSON.parse(localStorage.getItem(DATA_KEY)) || {
        session: null,
        users: {},
        events: [],
      }
    );
  } catch (e) {
    return { session: null, users: {}, events: [] };
  }
};

const saveData = (d) => {
  try {
    localStorage.setItem(DATA_KEY, JSON.stringify(d));
  } catch (e) {}
};

const userOf = (d, name) => {
  if (!d.users[name]) {
    d.users[name] = { draws: 0, skips: 0, completions: 0, questions: [] };
  }
  return d.users[name];
};

export const track = (type, name, q) => {
  const d = loadData();
  const at = Date.now();
  const no = q ? qNo(q) : null;
  const u = userOf(d, name);
  if (type === 'draw') {
    u.draws += 1;
    u.questions.push({ qNo: no, q, drawnAt: at, skips: 0, completedAt: null });
  }
  if (type === 'skip') {
    u.skips += 1;
    const last = u.questions[u.questions.length - 1];
    if (last) {
      last.skips += 1;
      last.qNo = no;
      last.q = q;
    }
  }
  if (type === 'complete') {
    u.completions += 1;
    const last = u.questions[u.questions.length - 1];
    if (last) {
      last.completedAt = at;
      last.qNo = no;
      last.q = q;
    }
  }
  d.events.push({ type, name, qNo: no, q, at });
  saveData(d);
};

export const startTracking = (names) => {
  const d = loadData();
  d.session = { startedAt: Date.now(), participants: names };
  names.forEach((n) => userOf(d, n));
  saveData(d);
};

// 현재 차례 사람 기준으로 아직 안 나온 질문에서 랜덤 추첨
export const drawQuestion = ({ history, skipped, currentName, exclude }) => {
  const seen =
    REPEAT_POLICY === 'unique-for-everyone'
      ? [...history, ...skipped]
      : [...history, ...skipped].filter((h) => h.name === currentName);
  const answered = seen.map((h) => h.q);
  let pool = QUESTIONS.filter((q) => !answered.includes(q) && q !== exclude);
  if (!pool.length) pool = QUESTIONS.filter((q) => q !== exclude);
  return pool[Math.floor(Math.random() * pool.length)];
};

// 유리 돔 안 공 배치 생성 (프로토타입 _genBalls 포팅)
export const genBalls = () => {
  const rows = [
    [78, 6],
    [65, 6],
    [53, 5],
    [42, 4],
    [33, 2],
  ];
  const out = [];
  rows.forEach(([y, n]) => {
    const half = Math.sqrt(Math.max(0, 42 * 42 - (y - 54) * (y - 54)));
    for (let i = 0; i < n; i++) {
      const s = 16 + Math.random() * 5;
      const span = Math.max(0, half * 2 - s);
      const x =
        50 -
        half +
        s / 2 +
        (n === 1 ? span / 2 : (span * i) / (n - 1)) +
        (Math.random() * 4 - 2);
      const c =
        Math.random() < 0.78
          ? PALETTE[Math.floor(Math.random() * 6)]
          : PALETTE[6 + Math.floor(Math.random() * 2)];
      out.push({
        l: +(x - s / 2).toFixed(1),
        t: +(y - s / 2 + Math.random() * 3 - 1.5).toFixed(1),
        s: +s.toFixed(1),
        c,
      });
    }
  });
  return out;
};
